import CancelOutlinedIcon from "@mui/icons-material/CancelOutlined";
import CategoryIcon from "@mui/icons-material/Category";
import { Grid, MenuItem, Stack } from "@mui/material";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { APP_ICONS } from "../../../assets";
import CustomSelect from "../../../components/customSelect";
import TextInput from "../../../components/TextInputs";
import { setProductCurrentPage } from "../../../lib/slices/productPageSlice";
import { setPackageCurrentPage } from "../../../lib/slices/packagePageSlice";
import {
  setSearchKeys,
  setUsersPlanEndDate,
  setUsersPlanName,
  setUsersPlanStartDate,
} from "../../../lib/slices/searchKeysSlice";
import { getAllEcomCategory } from "../../../services/ecomCategoryApiFn";
import { getAllEcomSubCategory } from "../../../services/ecomSubCategoryApiFn";
import { getAllEcomSubSubCategory } from "../../../services/ecomSubSubCategoryApiFn";
import { getAllSupplier } from "../../../services/supplierApiFn";
import { handleOpenSnackBar } from "../../../utils";
import CustomRangePicker from "../../../components/DateRangePicker";
import GlobalButton from "../../../components/CustomButton";
import SearchIcon from "@mui/icons-material/Search";
import { setUserPlanCurrentPage } from "../../../lib/slices/pagination/userPlanPageSlice";

const BasePackagesFilters = () => {
  const dispatch = useDispatch();
  const { t } = useTranslation(["products", "common"]);
  const [allCategories, setAllCategories] = useState([]);
  const [allSuppliers, setAllSuppliers] = useState([]);
  const searchKeys = useSelector((state) => state.searchKeysReducer.searchKeys);
  const userData = useSelector((state) => state.userData.user);
  const { currentLanguage } = useSelector((state) => state.languageReducer);

  const fetchchedAllCategories = async () => {
    try {
      const response = await getAllEcomCategory();
      if (response?.data?.status === "success") {
        setAllCategories(response?.data?.data);
      } else {
        console.error(response?.data?.message, "error");
      }
    } catch (error) {
      console.error(error?.message, "error");
    }
  };

  const fetchAllSuppliers = async () => {
    try {
      const response = await getAllSupplier("");
      if (response.data.status === "success") {
        const data = response.data.data.suppliers;
        setAllSuppliers(data);
      } else {
        console.error(response.data.message, "error");
      }
    } catch (error) {
      console.error(error.message, "error");
    }
  };

  useEffect(() => {
    fetchchedAllCategories();
    fetchAllSuppliers();
  }, []);

  return (
    <Stack p={2} bgcolor={"primary.light"}>
      <Grid container spacing={2}>
        <Grid item xs={12}>
          <TextInput
            InputStartIcon={<img src={APP_ICONS.searchGreyIcon} width={25} />}
            InputEndIcon={
              searchKeys.packageByName && (
                <CancelOutlinedIcon
                  fontSize="small"
                  sx={{ cursor: "pointer" }}
                  onClick={() => {
                    dispatch(
                      setSearchKeys({
                        ...searchKeys,
                        packageByName: "",
                      }),
                    );
                  }}
                />
              )
            }
            placeholder={t("searchByName", { ns: "common" })}
            value={searchKeys.packageByName}
            onChange={(e) => {
              dispatch(
                setSearchKeys({
                  ...searchKeys,
                  packageByName: e.target.value,
                }),
              );
            }}
          />
        </Grid>
        <Grid item xs={12} md={6} lg={4}>
          <CustomSelect
            formStyleProps={{
              "& .MuiInputBase-input": {
                textTransform: "capitalize",
              },
            }}
            icon={<CategoryIcon sx={{ fontSize: "15px", color: "#000000" }} />}
            value={searchKeys.ecomCategoryIdForPackage}
            onChange={(e) => {
              dispatch(setPackageCurrentPage(1));
              dispatch(
                setSearchKeys({
                  ...searchKeys,
                  ecomCategoryIdForPackage: e.target.value,
                }),
              );
            }}
          >
            <MenuItem value="All">
              {searchKeys.ecomCategoryIdForPackage === "All"
                ? t("selectCategory", { ns: "common" })
                : t("allCategories", { ns: "common" })}
            </MenuItem>
            {allCategories.map((val, ind) => {
              return (
                <MenuItem
                  key={ind}
                  value={val._id}
                  sx={{ textTransform: "capitalize" }}
                >
                  {val.name[currentLanguage]}
                </MenuItem>
              );
            })}
          </CustomSelect>
        </Grid>
        <Grid item xs={12} md={6} lg={4}>
          <CustomSelect
            placeholder={t("suppliers", { ns: "common" })}
            formStyleProps={{
              "& .MuiInputBase-input": {
                textTransform: "capitalize",
              },
            }}
            icon={<CategoryIcon sx={{ fontSize: "15px", color: "#000000" }} />}
            value={searchKeys.vendorsForPackage}
            onChange={(e) => {
              dispatch(setPackageCurrentPage(1));
              dispatch(
                setSearchKeys({
                  ...searchKeys,
                  vendorsForPackage: e.target.value,
                }),
              );
            }}
          >
            <MenuItem value="all">{t("all", { ns: "common" })}</MenuItem>
            {allSuppliers.map((val, ind) => {
              return (
                <MenuItem
                  key={ind}
                  value={val._id}
                  sx={{ textTransform: "capitalize" }}
                >
                  {val.businessName}
                </MenuItem>
              );
            })}
          </CustomSelect>
        </Grid>
      </Grid>
    </Stack>
  );
};

const ProductsFilters = () => {
  const dispatch = useDispatch();
  const { t } = useTranslation("common");
  const [allCategories, setAllCategories] = useState([]);
  const [allSubCategories, setAllSubCategories] = useState([]);
  const [allSubSubCategories, setAllSubSubCategories] = useState([]);
  const [allSuppliers, setAllSuppliers] = useState([]);
  const searchKeys = useSelector((state) => state.searchKeysReducer.searchKeys);
  const userData = useSelector((state) => state.userData.user);
  const { currentLanguage } = useSelector((state) => state.languageReducer);

  const fetchchedAllCategories = async () => {
    try {
      const response = await getAllEcomCategory();
      if (response?.data?.status === "success") {
        setAllCategories(response?.data?.data);
      } else {
        handleOpenSnackBar("error", response?.data?.message);
      }
    } catch (error) {
      handleOpenSnackBar("error", error?.message);
    }
  };

  const fetchchedAllSubCategories = async (value) => {
    try {
      const response = await getAllEcomSubCategory("", value);
      if (response?.data?.status === "success") {
        setAllSubCategories(response?.data?.data);
      } else {
        handleOpenSnackBar("error", response?.data?.message);
      }
    } catch (error) {
      handleOpenSnackBar("error", error?.message);
    }
  };

  const fetchchedAllSubSubCategories = async (value1, value2) => {
    try {
      const response = await getAllEcomSubSubCategory("", value1, value2);
      if (response?.data?.status === "success") {
        setAllSubSubCategories(response?.data?.data);
      } else {
        handleOpenSnackBar("error", response?.data?.message);
      }
    } catch (error) {
      handleOpenSnackBar("error", error?.message);
    }
  };

  const fetchAllSuppliers = async () => {
    try {
      const response = await getAllSupplier("");
      if (response.data.status === "success") {
        const data = response.data.data.suppliers;
        setAllSuppliers(data);
      } else {
        handleOpenSnackBar("error", response.data.message);
      }
    } catch (error) {
      handleOpenSnackBar("error", error.message);
    }
  };

  useEffect(() => {
    fetchAllSuppliers();
    fetchchedAllCategories();
  }, []);

  return (
    <Stack p={2} bgcolor={"primary.light"}>
      <Grid container spacing={2}>
        <Grid item xs={12}>
          <TextInput
            InputStartIcon={<img src={APP_ICONS.searchGreyIcon} width={25} />}
            InputEndIcon={
              searchKeys.productName && (
                <CancelOutlinedIcon
                  fontSize="small"
                  sx={{ cursor: "pointer" }}
                  onClick={() => {
                    dispatch(
                      setSearchKeys({
                        ...searchKeys,
                        productName: "",
                      }),
                    );
                  }}
                />
              )
            }
            placeholder={t("searchByName", { ns: "common" })}
            value={searchKeys.productName}
            onChange={(e) => {
              dispatch(
                setSearchKeys({
                  ...searchKeys,
                  productName: e.target.value,
                }),
              );
            }}
          />
        </Grid>
        <Grid item xs={12} md={6} lg={3}>
          <CustomSelect
            placeholder={t("category", { ns: "common" })}
            formStyleProps={{
              "& .MuiInputBase-input": {
                textTransform: "capitalize",
              },
            }}
            icon={<CategoryIcon sx={{ fontSize: "15px", color: "#000000" }} />}
            value={searchKeys.ecomCategoryId}
            onChange={(e) => {
              dispatch(setProductCurrentPage(1));
              fetchchedAllSubCategories(e.target.value);
              fetchchedAllSubSubCategories(e.target.value, "All");
              dispatch(
                setSearchKeys({
                  ...searchKeys,
                  ecomCategoryId: e.target.value,
                  ecomSubCategoryId: "All",
                  ecomSubSubCategoryId: "All",
                }),
              );
            }}
          >
            <MenuItem value={"All"}>{t("all", { ns: "common" })}</MenuItem>
            {allCategories.map((val, ind) => (
              <MenuItem
                key={ind}
                value={val._id}
                sx={{ textTransform: "capitalize" }}
              >
                {val.name[currentLanguage]}
              </MenuItem>
            ))}
          </CustomSelect>
        </Grid>
        <Grid item xs={12} md={6} lg={3}>
          <CustomSelect
            placeholder={t("subCategory", { ns: "common" })}
            formStyleProps={{
              "& .MuiInputBase-input": {
                textTransform: "capitalize",
              },
            }}
            icon={<CategoryIcon sx={{ fontSize: "15px", color: "#000000" }} />}
            value={searchKeys.ecomSubCategoryId}
            onChange={(e) => {
              dispatch(setProductCurrentPage(1));
              fetchchedAllSubSubCategories(
                searchKeys.ecomCategoryId,
                e.target.value,
              );
              dispatch(
                setSearchKeys({
                  ...searchKeys,
                  ecomSubCategoryId: e.target.value,
                  ecomSubSubCategoryId: "All",
                }),
              );
            }}
          >
            <MenuItem value={"All"}>{t("all", { ns: "common" })}</MenuItem>
            {allSubCategories.map((val, ind) => (
              <MenuItem
                key={ind}
                value={val._id}
                sx={{ textTransform: "capitalize" }}
              >
                {val.name[currentLanguage]}
              </MenuItem>
            ))}
          </CustomSelect>
        </Grid>
        <Grid item xs={12} md={6} lg={3}>
          <CustomSelect
            placeholder={t("subSubCategory", { ns: "common" })}
            formStyleProps={{
              "& .MuiInputBase-input": {
                textTransform: "capitalize",
              },
            }}
            icon={<CategoryIcon sx={{ fontSize: "15px", color: "#000000" }} />}
            value={searchKeys.ecomSubSubCategoryId}
            onChange={(e) => {
              dispatch(setProductCurrentPage(1));
              dispatch(
                setSearchKeys({
                  ...searchKeys,
                  ecomSubSubCategoryId: e.target.value,
                }),
              );
            }}
          >
            <MenuItem value={"All"}>{t("all", { ns: "common" })}</MenuItem>
            {allSubSubCategories.map((val, ind) => (
              <MenuItem
                key={ind}
                value={val?._id}
                sx={{ textTransform: "capitalize" }}
              >
                {val?.name[currentLanguage]}
              </MenuItem>
            ))}
          </CustomSelect>
        </Grid>
        <Grid item xs={12} md={6} lg={3}>
          <CustomSelect
            placeholder={t("suppliers", { ns: "common" })}
            formStyleProps={{
              "& .MuiInputBase-input": {
                textTransform: "capitalize",
              },
            }}
            icon={<CategoryIcon sx={{ fontSize: "15px", color: "#000000" }} />}
            value={searchKeys.vendorId}
            onChange={(e) => {
              dispatch(setProductCurrentPage(1));
              dispatch(
                setSearchKeys({
                  ...searchKeys,
                  vendorId: e.target.value,
                }),
              );
            }}
          >
            <MenuItem value="all">{t("all", { ns: "common" })}</MenuItem>
            {allSuppliers.map((val, ind) => (
              <MenuItem
                key={ind}
                value={val._id}
                sx={{ textTransform: "capitalize" }}
              >
                {val.businessName}
              </MenuItem>
            ))}
          </CustomSelect>
        </Grid>
      </Grid>
    </Stack>
  );
};

const UsersPlansFilters = ({ fetchData }) => {
  const dispatch = useDispatch();
  const { t } = useTranslation(["products", "common"]);
  const searchKeys = useSelector((state) => state.searchKeysReducer.searchKeys);

  return (
    <Stack
      p={2}
      direction={{ md: "row" }}
      alignItems={"center"}
      justifyContent={"space-between"}
      bgcolor={"primary.light"}
    >
      <TextInput
        styleProps={{ width: { xs: "100%", md: "35%", xl: "30%" } }}
        InputStartIcon={<img src={APP_ICONS.searchGreyIcon} width={25} />}
        InputEndIcon={
          searchKeys.usersPlanName && (
            <CancelOutlinedIcon
              fontSize="small"
              sx={{ cursor: "pointer" }}
              onClick={() => {
                dispatch(setUsersPlanName(""));
              }}
            />
          )
        }
        placeholder={t("searchByName", { ns: "common" })}
        value={searchKeys.usersPlanName}
        onChange={(e) => {
          dispatch(setUsersPlanName(e.target.value));
        }}
      />

      <Stack direction={"row"} alignItems={"center"}>
        <CustomRangePicker
          startDate={searchKeys.usersPlanStartDate}
          setStartDate={(value) => {
            // dispatch(setUserPlanCurrentPage(1));
            dispatch(setUsersPlanStartDate(value));
          }}
          endDate={searchKeys.usersPlanEndDate}
          setEndDate={(value) => {
            // dispatch(setUserPlanCurrentPage(1));
            dispatch(setUsersPlanEndDate(value));
          }}
          stackProps={{
            borderRadius: "6px 0px 0px 6px",
            border: "1px solid #dddddd",
          }}
        />
        <GlobalButton
          endIcon={<SearchIcon />}
          handleClickBtn={() => {
            fetchData();
          }}
          styleProps={{
            color: "primary",
            width: "auto",
            borderRadius: "0px 6px 6px 0px",
            minWidth: 45,
            height: "42px",
            "& .MuiButton-icon": {
              marginLeft: "0px",
            },
          }}
        />
      </Stack>
    </Stack>
  );
};

export { BasePackagesFilters, ProductsFilters, UsersPlansFilters };
